<template>
    <div>
        <div class="BarKemajuan">
            <div v-for="(item,index) in list" :key="index" style="flex: 1;">
                <!-- 第一行 -->
                <div style="display: flex;align-items: center;">
                    <div v-if="index!=0" :class="[ schedule>=item.schedule?'line':'line1']" style="flex: 1;"></div>
                    <div v-else style="flex: 1;"></div> 
                    <div :class=" [schedule>=item.schedule?'ImgBox':'ImgBox1']">
                    </div>
                    <div v-if="index<list.length-1" :class="[schedule>item.schedule? 'line':'line1']" style="flex: 1;"></div>
                    <div v-else style="flex: 1;"></div>
                </div>
                <!-- 第二行 -->
                <div :class="[schedule>=item.schedule?'title':'title1']">{{ item.title }}</div>
            </div>
        </div>
       
    </div>

</template>
<script>
    export default {
        props:{
            // 列表值
            list: {
                type: Array,
                default: () => [],
            },
            schedule:{
                type:String,
                default:''
            }
        }
    }
</script>
<style lang="scss" scoped>
.BarKemajuan{
    display: flex;
    text-align: center;
}
.title1{
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    font-weight: 600;
}
.title{
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    font-weight: 600;
}
.ImgBox{
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background:  $mainBody-color;
    margin:10px 0;
}
.ImgBox1{
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #999999;
    margin:10px 0;
}
.line{
   height: 2px;
   background:  $mainBody-color;
}
.line1{
    height: 2px;
    background: #999999;

}
</style>